import { useRouter } from 'next/router';
import EfImg from 'elem/ui/ef-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: React.FC<{
    needTitle?: boolean;
}> = ({ needTitle = true }) => {
    const { t } = useLang('dp3.teaser.TextA');
    const { locale } = useRouter();

    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726666226206/1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1727331574618/Frame%201000008603.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726666372672/3.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726666226405/2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1727331575082/Frame%201000008604.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726666372453/1.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726666226772/3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1727331575282/Frame%201000008604%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726666372893/2.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726666226586/4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1727331574875/Frame%201000008605.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726666372222/4.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726666226024/5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1727331575501/Frame%201000008606.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726666372021/5.jpg',
        },
    ];

    return (
        <div
            id="dp3-teaser-C"
            className={`${css.thecomp} dp3-teaser-C GtmModuleData-section`}
            style={{ backgroundColor: needTitle ? undefined : '#fff' }}
            data-section-id={'dp3-TextA'}
            data-section-title={'dp3-TextA'}
        >
            {needTitle && (
                <h2 className="dp3-title TextA-title">
                    {t.rich('title', {
                        color2: (text: string) => <span className="TextA-color2">{text}</span>,
                    })}
                </h2>
            )}
            {locale === 'au' && (
                <ul className="yyds" style={{ marginTop: needTitle ? undefined : 0 }}>
                    {items.map((item, k: number) => (
                        <li className={`item item${k + 1}`} key={k}>
                            <div className="item-img">
                                <EfImg pc={item?.pc} pad={item?.pad} h5={item?.h5} />
                            </div>
                            <div className="item-info">
                                <p className="item-title">{t(`item${k + 1}_title`)}</p>
                                <p className="item-desc">{t(`item${k + 1}_desc`)}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default TheComp;
